import { httpClientRepository } from '@bg-shared/infrastructure/HttpClient';
import { API_URLS } from '@bg-shared/constants/apiUrls';
import { GameId } from '@bg-shared/enums/GameId';
import { IBettingOptionsService } from './interfaces';

class BettingOptionsService implements IBettingOptionsService {
    public async fetchTopOptions() {
        try {
            const response = await httpClientRepository.get<Record<GameId, number[]>>(
                API_URLS.POPULAR_ODDS,
            );
            return response;
        } catch (e) {
            console.error(`Betting options service error ${JSON.stringify(e)}`);
            return null;
        }
    }
}

export const bettingOptionsService = new BettingOptionsService();
